import type { ReactNode } from 'react';
import { Header } from './Header';
import { ImpersonationBanner } from './ImpersonationBanner';
import { OfflineBanner } from './OfflineBanner';

export function RootLayout({ children }: { children: ReactNode }): React.ReactElement {
  return (
    <div className="sl-app">
      <OfflineBanner />
      <ImpersonationBanner />
      <Header />
      <main className="sl-main">{children}</main>
    </div>
  );
}
